var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CtaBoxCmp"},[_c('div',{class:[
      'wrapper',
      { 'shadow-soft': _vm.themeVariant !== 'squared' || _vm.lgAndDown } ]},[_vm._t("default"),(_vm.themeVariant !== 'squared' || _vm.lgAndDown)?_c('div',{staticClass:"icon-wrapper"},[_c('svg',[_c('use',{attrs:{"href":"#icon-arrow-right"}})])]):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }